import type { FC } from "react";

import {
  type TResponsiveNavigationProps,
} from "@/ui/components/navigation/ResponsiveNavigation/ResponsiveNavigation.config";
import {
  ResponsiveNavigationItem,
} from "@/ui/components/navigation/ResponsiveNavigation/ResponsiveNavigationItem";
import { cn } from "@/ui/lib/utils";
import { useTranslations } from "next-intl";

export const ResponsiveNavigation: FC<TResponsiveNavigationProps> = (
  {
    activeValue,
    items,
    className,
    ariaLabel,
    ...props
  },
) => {
  const t = useTranslations("Libs.UI.Components.ResponsiveNavigation");
  return (
    <nav
      {...props}
      data-component="ResponsiveNavigation"
      aria-label={ariaLabel || t("label")}
      className={cn(
        "fixed inset-x-0 bottom-0 z-40 border-t border-solid border-component-responsive-navigation bg-component-responsive-navigation shadow-sm",
        "xl:inset-y-0 xl:left-0 xl:right-auto xl:w-64 xl:border-r xl:border-t-0 xl:px-4 xl:py-6",
        className,
      )}
    >
      <ul className="flex items-stretch justify-around gap-1 px-2 py-2 xl:flex-col xl:justify-start xl:gap-4 xl:px-0 xl:py-0">
        { items.map((item) => (
          <ResponsiveNavigationItem
            key={item.value}
            item={item}
            isActive={item.value === activeValue}
          />
        )) }
      </ul>
    </nav>
  );
};

ResponsiveNavigation.displayName = "ResponsiveNavigation";
